import * as React from "react";
import { Row, NavLink } from 'reactstrap';
import { NavLink as RRNavLink } from 'react-router-dom';
import { INotification, NotificationType } from "src/modules/Auth/store/types";
import { timestampToMoment } from "src/share/utils/utils";
import environmentHelper from "src/share/utils/environmentHelper";

export interface INotificationProps {
  notification: INotification;
}
export interface INotificationState {
  extensions: {
    [key: string]: boolean
  };
  error: boolean
}

export class NotificationCase extends React.Component<INotificationProps, INotificationState>{
  constructor(props: INotificationProps) {
    super(props);
    this.state = {
      extensions: {
        png: false,
        jpg: false,
        jpeg: false,
      },
      error: false
    }
  }
  public onErrorImage = (e: any) => {
    this.setState({ error: true })
    e.target.onerror = null;
    const extension = Object.keys(this.state.extensions).find((key) => !this.state.extensions[key]);
    if (typeof extension === 'string') {
      this.setState({ extensions: { ...this.state.extensions, [extension]: true } })
    }
  }
  public getUrl(notification: INotification) {
    const extension = Object.keys(this.state.extensions).reduce((value, key) => !value && !this.state.extensions[key] ? key : value, null);
    if (this.state.error && notification.type === NotificationType.Case && extension) {
      return `${environmentHelper.getRekognitionImageRoot()}/icmec/${notification.caseId}/${notification.childId}/portrait.${extension}`
    } else {
      return notification.imageUrl;
    }
  }
  public getLink(notification: INotification) {
    return notification.type === NotificationType.Match ?
      `/rekognition/matches/${notification.caseId}/${notification.childId}` : `/case/information/${notification.caseId}`
  }
  public onImageLoad = () => {
    this.setState({ error: false })
  }
  public render() {
    const { notification } = this.props;
    return (
      <div className="notification">
        <NavLink to={this.getLink(notification)} tag={RRNavLink} >
          <Row>
            <img src={this.getUrl(notification)} onLoad={this.onImageLoad} onError={this.onErrorImage} />
            <div className="notificationContainer">
              <h5 className="title">{notification.title}</h5>
              <p className="subTitle subFont">{notification.subTitle}</p>
              <p className="extra subFont">{timestampToMoment(notification.date).fromNow()}</p>
            </div>
          </Row>
        </NavLink>
      </div>
    );
  }
}